module.exports = __webpack_public_path__ + "static/water-1272067fd11cf29938c70ce785250d0e.png";